import React from 'react';
import styles from "./ReportsandInsights.module.scss";
import { useNavigate } from 'react-router-dom';
import StatusBadge from '../../../common/AdminCommonComponents/StatusBadge/StatusBadge';
import ActionButton from '../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton';
import DynamicTableFilters from '../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters';
import DynamicDatatable from '../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import { inventoryLevelsTableData, reportingInsightsTableData } from '../../../../views/AdminPortal/dummyData';
import BlueBadge from '../../../common/AdminCommonComponents/BlueBadge/BlueBadge';

const ReportsAndInsights = () => {
    const navigate = useNavigate();

    const dropdownOptions = [
        { label: "View details", action: () => console.log("View details") },
        { label: "Edit", action: () => console.log("Deactivate Product") },
        { label: "Delete", action: () => console.log("Notify Seller") },
    ];



    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Category",
            selector: (row) => row.category,
            center: "true",
            width: "150px",
        },
        {
            name: "Average Monthly Sales",
            selector: (row) => row.averageMonthlySales,
            center: "true",
        },
        {
            name: "Stock Turnovers (Days)",
            selector: (row) => row.stockTurnover,
            center: "true",
        },
        {
            name: "Top Low-Stock Products",
            cell: (row) => <BlueBadge>{row.topLowStock}</BlueBadge>,
            center: "true",
        },
        {
            name: "Restock Frequency Needed",
            selector: (row) => row.restockNeeded,
            center: "true",
        },
        {
            name: "Action",
            cell: (row) => <ActionButton options={dropdownOptions} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div>
            <DynamicTableFilters componentName={"Stock Monitoring"} apply={false} onClear={handleClear} />
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={reportingInsightsTableData}
                    columns={columns}
                    type="gray"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default ReportsAndInsights;